import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import {
    EnderecoToEnderecoNameFullPipe,
    UnidadeToUnidadeNameFullPipe,
    NumberToSexoPipe,
    BoolToDistribuicaoEquitativaPipe,
    BoolToVigenciaPipe
} from './pipes/custom.pipe';

@NgModule({
    imports: [ BrowserModule ],
    declarations: [
        BoolToVigenciaPipe,
        BoolToDistribuicaoEquitativaPipe,
        NumberToSexoPipe,
        UnidadeToUnidadeNameFullPipe,
        EnderecoToEnderecoNameFullPipe,
    ],
    exports: [
        BoolToVigenciaPipe,
        BoolToDistribuicaoEquitativaPipe,
        NumberToSexoPipe,
        UnidadeToUnidadeNameFullPipe,
        EnderecoToEnderecoNameFullPipe
    ]
})
export class EmpregoNaPistaSharedModule { }



// WEBPACK FOOTER //
// ./src/app/components/shared/emprego-na-pista-shared.module.ts